import { combineReducers } from 'redux';

import data from './data';
import coordenades from './coordenades';
import idVigilant from './idVigilant';
import idMeteorSeleccionat from './idMeteorSeleccionat';
import valors from './valors';

export default combineReducers({
    data,
    coordenades,
    idVigilant,
    idMeteorSeleccionat,
    valors
});



// WEBPACK FOOTER //
// ./src/reducers/avis/formulari/errors/index.js